var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB4Date(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 13v4.44a5 5 0 11-10 0V13H32v4.44a5 5 0 11-10 0V13h-8v53h38.9L62 55.76V13h-8zm4 40h-8v9H18V28h40v25zM47 17.44V9a2 2 0 114 0v8.44a2 2 0 01-4 0zM37 41h-4v-2.82a7.92 7.92 0 001.63-.18 4.35 4.35 0 001.43-.52 3.52 3.52 0 001.07-1c.29-.448.48-.952.56-1.48H41v18h-4V41zM25 17.44V9a2 2 0 114 0v8.44a2 2 0 01-4 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B4_Date.5b135183.svg";
export { SvgB4Date as ReactComponent };